export default __webpack_public_path__ + "static/media/team1-1.9032df0a.png";